<template>
	<div v-loading="loading">

		<div class="pagemain">
			<el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="left">
				<div class="mm-row">
					<div class="mm-item">
						<el-form-item label="回復給" prop="to">
							<el-input v-model="form.to" readonly=""></el-input>
						</el-form-item>
					</div>
				</div>
				<div class="mm-row">
					<div class="mm-item">
						<el-form-item label="消息模板">
							<el-select class="elselect" @change="choose_template" v-model="template">
								<el-option label="訂單已修改，請查看" value="訂單已修改，請查看"></el-option>
								<el-option label="訂單有誤，請修改" value="訂單有誤，請修改"></el-option>
							</el-select>
						</el-form-item>

					</div>
				</div>
				<div class="mm-row">
					<div class="mm-item">
						<el-form-item label="消息"  prop="content">
							<el-input type="textarea" v-model="form.content"></el-input>
						</el-form-item>
					</div>
				</div>
				<div class="mm-row">
					<el-form-item>
						<el-button @click="fromsumbit('form')" type="primary">發送</el-button>

					</el-form-item>
				</div>

			</el-form>
		</div>
	</div>

</template>

<script>
	export default {
		name: "replaymessage",
		props: ['replay'],
		data() {
			return {
				template: '',
				loading: false,
				form: {
					order_id:0,
					ordernum:'',
					from_id:0,
					to: '',
					to_id:0,
					content: '',
					replay:1

				},
				rules: {
					to: [{
						required: true,
						message: '请填写发送目标用户',
					}, {
						pattern: /^[\S]+$/,
						message: '只能輸入可見字符'
					}],
					content: [{
						required: true,
						message: '请添加发送内容',
					}],


				}
			}
		},

		methods: {
			choose_template(content) {
				this.form.content = content;
			},
			fromsumbit(form) {

				this.$refs[form].validate((valid) => {
					if (valid) {
						
						let data = this.form;
						
						this.post('/api/message/addsave', {
							data: data
						}).then((res) => {
						
							if (res == 'success') {
								let username = this.sessionRead('username');
								let thumb = this.sessionRead('thumb');
								let swoolecontent ={
									'type':'message',
									 username:username,
									 thumb:thumb,
									'content':'回复:'+data.content
								};
								this.wssend(this.form.from_id,this.form.to_id,swoolecontent);
								this.$message({
									showClose: true,
									message: '消息回复成功！',
									type: 'success',
									onClose: (() => {
										this.$emit('closedialog');
									})
								});
							} else {
								this.$message({
									showClose: true,
									message: '消息回复失败，請重試！',
									type: 'error',
											
								});
							}
											
							this.loading = false;
						}).catch((err) => {
							this.loading = false;
							console.log(err)
						});
						
					}
				});
			},
			wssend(from_id,to_id,content){
				let swoolecontent = JSON.stringify(content);
				let databasename = localStorage.getItem(databasename);
				let data ={
					databasename:databasename,
					from_id:from_id,
					to_id:to_id,
					content:swoolecontent
				}
				websocket.send(JSON.stringify(data));
				this.$emit('parentmsg', '1');
			},
		},
		created() {
			
			this.form.to = this.replay.from_username;
			this.form.order_id = this.replay.order_id;
			this.form.ordernum = this.replay.ordernum;
			this.form.from_id = this.replay.to_id;
			this.form.to_id = this.replay.from_id;
		}




	}
</script>

<style>
	.el-form-item {
		flex: 1;
	}
</style>
